<template>
  <div id="left" :class="{ left_hide: $store.state.menu.status }">
    <ul>
      <li
        v-for="(item, index) in items"
        :key="index"
        :class="{ active: myIndex == index }"
      >
        <div class="title" @click="toggle(item, index)">
          <Icon
            :type="item.expand ? 'ios-arrow-down' : 'ios-arrow-forward'"
          /><span v-if="!$store.state.menu.status">{{ item.name }}</span>
          <Badge :count="item.num" v-if="item.num != 0"> </Badge>
        </div>

        <dl
          :class="{ expand: !item.expand }"
          :style="{ height: item.childList.length * 30 + 20 + 'px' }"
         
        >
          <router-link
            v-for="(sub, index) in item.childList"
            :key="index"
            :to="{ path: sub.link, query: { now: myIndex } }"
            :class="{ routeractive: nowPath == sub.link }"
            custom
            v-slot="{ navigate }"
            @click.native="clickMenu(sub)"
          >
            <dd @click="navigate">
              <span>{{ sub.name }}</span>
              <Badge
                dot
                v-if="sub.num != 0"
                style="margin-bottom: 10px; margin-left: 4px"
              >
              </Badge>
            </dd>
          </router-link>
        </dl>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      items: [],
      myIndex: 0,
      topMenuList: [],
      nowPath: this.$route.path,
    };
  },

  methods: {
    getMenu(){},
    getData() {
      this.axios({
        method: "post",
        url: "/account/getAccountAuthoritie",
        data: {},
      }).then((res) => {
        var data = res.data.data;
        //console.log(data);
        var that = this;

        function menuData(m, arr = []) {
          for (let i = 0; i < m.length; i++) {
            //m[i].children = m[i].childList;
            m[i].expand = false;
            m[i].num = 0;
     
            if (m[i].link == that.$route.path && m[i].type == 1) {
              m[i].now = that.$route.query.now;

              that.$store.state.topMenuList.push(m[i]);
              that.$store.state.nowActiveTitle = m[i].name;
            }
            let node = { ...m[i], childList: [] };
            if (node.type == 1) {
              arr.push(node);
            }

           
            if (m[i].childList.length > 0) {
              menuData(m[i].childList, node.childList);
            }
          }
          return arr;
        }
        this.items = menuData(data);
        this.$store.state.nav = data;
        this.items[this.myIndex].expand = true;
      });
    },
    addDots() {
      var t;
      t = setInterval(() => {
        var m = this.items;
        if (m.length > 0) {
          clearInterval(t);
          var nn = this.$store.state.dots;

          function menuData(m) {
            for (let i = 0; i < m.length; i++) {
          
              m[i].num = 0;

              if (nn) {
                for (const j in nn) {
                  if (m[i].name == j) {
                    m[i].num = nn[j];
                  }
                }
              }

              if (m[i].childList.length > 0) {
                menuData(m[i].childList);
              }
            }
            return m;
          }
          menuData(m);
        }
      }, 1000);
    },
    toggle(item, index) {
      this.myIndex = index;
      if (this.$store.state.menu.status) {
        return;
      }
      for (let i = 0; i < this.items.length; i++) {
        if (i == this.myIndex) {
          //跳过当前选中的菜单
          continue;
        }
        this.items[i].expand = false;
      }

      this.items[this.myIndex].expand = !this.items[this.myIndex].expand;
    },
    //刷新自动回到刚刚打开的页面
    openNow(to) {
    
      if (to) {
        //:to="{path:sub.link,query:{now:$store.state.this.myIndex}}",在html里边设置这个
        this.myIndex = to;
        for (let i = 0; i < this.items.length; i++) {
          this.items[i].expand = false;
          this.items[this.myIndex].expand = true;
        }
        //this.items[this.myIndex].expand = true
      } else {
        this.myIndex = 1;
        this.$store.commit("changeIndex", 2);
      }
    },
    clickMenu(row) {
      setTimeout(() => {
        var result = this.$store.state.topMenuList.some((item) => {
          if (item.id == row.id) {
            return true;
          }
        });
        if (!result) {
          row.now = this.$route.query.now;
          this.$store.state.topMenuList.push(row);
          this.$route.meta.keepAlive = true
        }
      }, 100);
    },
  },
  computed: {
    listData() {
      return this.$store.state.menu.status;
    },
    dots() {
      return JSON.parse(JSON.stringify(this.$store.state.dots));
    },
  },
  watch: {
    //如果收缩模式。需要将所有的子集菜单展开
    listData(val) {
      //在$route监听里边也有一段一样的代码。后期要优化
      if (val) {
        for (const i in this.items) {
          this.items[i].expand = true;
        }
      } else {
        for (const i in this.items) {
          this.items[i].expand = false;
        }
        this.items[this.myIndex].expand = true;
      }
    },
    //监听路由变化https://www.cnblogs.com/crazycode2/p/8727410.html
    $route(to) {
      this.nowPath = to.path;
      this.openNow(to.query.now);
    },
    dots(v) {
      
      this.addDots();
    },
  },
  mounted() {
    this.getData();
    this.openNow(this.$route.query.now);
  },
};
</script>
<style>
#left {
  background: var(--themeColor);
  float: left;
  width: 150px;
  height: 100%;
  overflow-y: auto;
  -ms-overflow-style: none;
  padding-top: 70px;
  transition: width 0.3s;
}
#left li:hover div.title,
#left li.active div.title {
  font-weight: bold;
  background: var(--adornColor);
}
#left li dl {
  background: rgba(0, 0, 0, 0.1);
  width: 100%;
  padding-left: 37px;
  transition: height 0.6s;
  position: relative;
  transition: height 0.5s;
  overflow: hidden;
}
#left ul li dl.expand {
  height: 0 !important;
}
#left li dl dd {
  color: var(--fontColor);
  opacity: 0.6;
}
#left li dl dd:first-child {
  margin-top: 10px;
}
#left li div.title i {
  color: var(--fontColor);
  opacity: 0.5;
}
#left li div.title span {
  color: var(--fontColor);
}
#left::-webkit-scrollbar {
  width: 0 !important;
}
.left_hide {
  width: 0px !important;
  overflow: hidden !important;
}
.left_hide ul li {
  position: relative;
}

#left li {
  text-align: left;
  cursor: pointer;
}
#left li div.title {
  font-size: 16px;
  padding-left: 1em;
  line-height: 2.5;
  transition: background 0.6s;
}
#left li div.title span {
  
  zoom: 1.1;
}

#left li div.title .icon-up-down {
  float: right;
  line-height: 2.9;
  margin-right: 0.8em;
  color: var(--fontColor);
}
#left li div.title .ivu-icon-ios-arrow-down {
  color: var(--fontColor);
}

#left li dl dd {
  font-size: 14px;
  line-height: 30px;
}

#left li dl a {
  line-height: 2.5;
  font-size: 14px;
  color: #999;
}

#left li dl dd:hover,
#left li dl a:hover,
#left li dl dd.routeractive {
  color: var(--fontColor);
  opacity: 1;
}
#left li dl dd dl.three {
  width: 100%;
  padding-left: 20px;
}
</style>




// WEBPACK FOOTER //
// ../common/src/components/sys/sysMenu.vue